export class HashUtil {
    static encode(data: string): string | null {
        try {
            if (!data) return null;
            const base64 = btoa(encodeURIComponent(data));
            return base64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
        } catch {
            return null;
        }
    }

    static decode(hashed: string): string | null {
        try {
            if (!hashed) return null;
            let base64 = hashed.replace(/-/g, '+').replace(/_/g, '/');
            while (base64.length % 4) {
                base64 += '=';
            }
            const decoded = atob(base64);
            return decodeURIComponent(decoded);
        } catch {
            return null;
        }
    }
}
